<template>
    <div>
        <table class="table w-100 table-hover lightgray-content">
            <thead>
                <tr>
                    <th></th>
                    <th>{{ !event.reserva_instalaciones ? $t('evento.tipo_entrada', { entrada: footer.termino_entrada }) : $t('gracias.tipo_reserva') }}</th>
                    <th>{{ $t('evento.precio') }}</th>
                    <th>{{ $t('evento.cantidad') }}</th>
                </tr>
            </thead>
            <tbody>
                <template v-for="(entrada, index) in entradas">
                    <tr :key="index" valign="middle">
                        <td :class="getEntradasMax(entrada) > 0 ? 'availability' : 'availability not-available'"></td>
                        <td>{{ entrada.name }}</td>
                        <td>{{ entrada.total_price | formatear_precio }}</td>
                        <td>
                            <div class="m-0 form-group" v-if="getEntradasMax(entrada) > 0">
                                <select
                                    class="form-control"
                                    data-cy="selector-entradas"
                                    v-model="entrada.unidades"
                                    @change="actualizar"
                                    :disabled="puede_seleccionar ? false : true"
                                    :aria-label="selectorAriaLabel(entrada)"
                                >
                                    <option :value="0">0</option>
                                    <template v-for="i in getEntradasMax(entrada)">
                                        <template v-if="i >= getEntradasMin(entrada)">
                                            <option :key="i" :value="i">{{ i }}</option>
                                        </template>
                                    </template>
                                </select>
                            </div>
                            <template v-else>
                                <template v-if="entrada.en_sesion == true">
                                    <b class="text-danger">En estos momentos un usuario está comprando las últimas {{ terminoEntradas }}, si no finaliza la compra se liberarán.</b>
                                </template>
                                <template v-else>
                                    <b class="text-danger" role="status" style="text-transform: uppercase">{{ terminoEntradas }} AGOTADAS</b>
                                </template>
                            </template>
                        </td>
                    </tr>
                    <tr :key="index + '-'">
                        <td colspan="5" class="pb-0">
                            <b-row class="pl-3">
                                <ResumenPrecioComponent
                                    :price="entrada.price"
                                    :price_management="entrada.price_management"
                                    :price_management_interno="entrada.price_management_interno"
                                    :iva="iva"
                                />
                                <b-col cols="12" style="text-transform: none;" class="mt-1 mb-1">
                                    {{ entrada.informacion }}
                                </b-col>
                            </b-row>
                        </td>
                    </tr>
                </template>
            </tbody>
        </table>
    </div>
</template>

<script setup>
    import { computed, toRef } from 'vue';
    import store from '@/store';
    import ResumenPrecioComponent from "@/components/frontend/compra/components/ResumenPrecioComponent.vue";
    import { useCupoPorEntrada } from '@/composables/front/events/useCupoPorEntrada';

    const props = defineProps(['entradas', 'puede_seleccionar', 'iva', 'event']);
    const emit = defineEmits(['actualizar']);

    const footer = computed(() => store.getters.getFooter);
    // Guard against the footer being null on first render (e.g. during the
    // initial GET before the action has hydrated `FrontEventsModule.footer`).
    // Optional chaining produces no Vue render warning when the store has not
    // yet resolved the footer, while the fallback keeps the user-visible text
    // safe and consistent.
    const terminoEntradas = computed(() => footer.value?.termino_entradas || 'entradas');

    const entradasRef = toRef(props, 'entradas');

    const stockCompartido = computed(() => Boolean(props.event?.stock_compartido));
    const cupoCompartido = computed(() => {
        if (!stockCompartido.value) {
            return null;
        }
        // Pass through NaN/negative so the composable's FAILSAFE branch can
        // surface a drift error instead of silently going to the legacy path.
        return Number(props.event?.cupo_disponible);
    });
    const preventaActiva = computed(() => Boolean(props.event?.preventa?.venta_preventa_activa));
    const preventaMax = computed(() => {
        if (!preventaActiva.value) {
            return null;
        }
        const raw = props.event?.n_max_asientos;
        const numeric = Number(raw);
        return Number.isFinite(numeric) ? numeric : null;
    });

    const getEntradasMax = useCupoPorEntrada(entradasRef, cupoCompartido, preventaMax);

    const actualizar = () => {
        const ok = props.entradas.some(entrada => entrada.unidades > 0);

        if (ok) {
            emit('actualizar', true);
        } else {
            emit('actualizar', false);
        }
    };

    const getEntradasMin = entrada => {
        return entrada.n_entradas_min ? entrada.n_entradas_min : 1;
    };

    // REQ-NF-A11Y-01: the <select> exposes an aria-label that reflects the
    // current cap when the stock_compartido branch is active. For the legacy
    // branch the label falls back to the entrada name (safe default).
    const selectorAriaLabel = entrada => {
        const cap = getEntradasMax(entrada);

        if (stockCompartido.value && Number.isFinite(cap) && cap >= 0) {
            return `${entrada.name} (máximo ${cap})`;
        }

        return entrada.name;
    };
</script>
